import addRoute from '@/router/add-route';

const APIKeys = () => import('@/modules/api-keys/api-keys.vue');
const APIKeysForm = () => import('@/modules/api-keys/api-key-form.vue');

const apiKeys = [
    addRoute({
        name: 'api-keys',
        path: '/api-keys',
        component: APIKeys,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'add-api-key',
        path: '/api-keys/add',
        component: APIKeysForm,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'update-api-key',
        path: '/api-keys/update/:id/:continue?',
        component: APIKeysForm,
        root: {label: 'Automations', name: 'automations'},
    }),
];

export default apiKeys;
